import { create, test, enforce } from 'vest';
import { formTypes } from './types';

export const formValidation = create('SetPasswordForm', (data = {}) => {
  // Password validation
  test('password', 'Password must be at least 8 characters long', () => {
    enforce(data.password).longerThanOrEquals(8);
  });

  test('password', 'Password must contain at least one uppercase letter', () => {
    enforce(data.password).matches(/[A-Z]/);
  });

  test('password', 'Password must contain at least one lowercase letter', () => {
    enforce(data.password).matches(/[a-z]/);
  });

  test('password', 'Password must contain at least one number', () => {
    enforce(data.password).matches(/[0-9]/);
  });

  test('password', 'Password must contain at least one special character (!@#$%^&*)', () => {
    enforce(data.password).matches(/[!@#$%^&*(),.?":{}|<>]/);
  });

  // Confirm password validation
  test('password_repeat', 'Passwords do not match', () => {
    enforce(data.password_repeat).equals(data.password);
  });
});
